/** @jsxImportSource @emotion/react */
import { Text } from 'grommet'

import { SimpleTag } from 'db-tables'

import Chip from './Chip'

export default function TagChip({ id, name }: SimpleTag) {
  return <Chip key={id} label={<Text size="xsmall">{name}</Text>} css={{ paddingTop: 'inherit' }} />
}
